import {EditUsersTariffPlans} from './edit-users-tariff-plans';

export default EditUsersTariffPlans;
